module.exports = __webpack_public_path__ + "media/images/lb/820-1657f08fe1937bf2922a40138a822136.svg";